import { routerShape } from '@bibliocommons/bc-prop-types';
import { setBackTo } from '@bibliocommons/utils-rails';
import isEqual from 'lodash/isEqual';
import BcReactComponent from '@bibliocommons/base-bc-react-component';

/**
 * This is a list of url patterns to ignore when updating the rails "back to" link.
 * We shouldn't need to add anything to this. Pages can opt out of updating backTo links
 * by not defining getBackToTitleKey().
 */
const BACK_TO_BLACKLIST = ['/availability/'];

const shouldUpdateBackTo = url => BACK_TO_BLACKLIST.every(blacklistedItem => !url.includes(blacklistedItem));

/**
 * This is a base class for page-level containers (containers that correspond to routes).
 *
 * If you extend this class and override react life cycle methods like
 * componentDidMount remember to call super.componentDidMount(), etc.
 */
/** @extends React.Component */
class BasePageContainer extends BcReactComponent {
  componentDidMount() {
    this.updateBackTo(window.location.href);
  }

  componentDidUpdate(prevProps) {
    const { router } = this.props;

    if (router && !isEqual(router.location, prevProps.router.location)) {
      this.updateBackTo(window.location.href);
    }
  }

  updateBackTo(url) {
    const getBackToTitleKey = this.getBackToTitleKey
      ? this.getBackToTitleKey.bind(this)
      : this.constructor.getBackToTitleKey;
    const title = getBackToTitleKey && getBackToTitleKey();
    if (title && url && shouldUpdateBackTo(url)) {
      setBackTo({ title, url });
    }
  }
}

BasePageContainer.propTypes = {
  router: routerShape
};

export default BasePageContainer;
